(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collections-directory"]) return;
  try {
    
  (() => {
    const initializeDirectory = (root) => {
      const directories = root.querySelectorAll('[data-collections-directory]:not([data-directory-initialized])');

      directories.forEach((directory) => {
        directory.setAttribute('data-directory-initialized', 'true');

        const search = directory.querySelector('[data-directory-search]');
        const categories = Array.from(directory.querySelectorAll('[data-directory-category]'));
        const noResults = directory.querySelector('[data-directory-no-results]');

        if (search && categories.length) {
          search.addEventListener('input', () => {
            const query = search.value.trim().toLocaleLowerCase();
            let totalMatches = 0;

            categories.forEach((category) => {
              let categoryMatches = 0;
              const linkItems = Array.from(category.querySelectorAll('[data-directory-link-item]'));

              linkItems.forEach((item) => {
                const link = item.querySelector('[data-directory-link]');
                const matches = !query || link.textContent.trim().toLocaleLowerCase().includes(query);
                item.hidden = !matches;

                if (matches) {
                  categoryMatches += 1;
                  totalMatches += 1;
                }
              });

              category.querySelectorAll('[data-directory-subgroup]').forEach((subgroup) => {
                const visibleLinks = subgroup.querySelectorAll('[data-directory-link-item]:not([hidden])');
                subgroup.hidden = visibleLinks.length === 0;
              });

              category.hidden = categoryMatches === 0;

              if (query && categoryMatches > 0) {
                category.open = true;
              }
            });

            if (noResults) {
              noResults.hidden = totalMatches > 0;
            }
          });
        }

        const loadMore = directory.querySelector('[data-collections-load-more]');
        const grid = directory.querySelector('[data-collections-grid]');
        const status = directory.querySelector('[data-collections-load-status]');

        if (!loadMore || !grid) {
          return;
        }

        directory.classList.add('collections-directory--enhanced');

        loadMore.addEventListener('click', async (event) => {
          event.preventDefault();
          const nextUrl = loadMore.dataset.nextUrl;

          if (!nextUrl || loadMore.getAttribute('aria-disabled') === 'true') {
            return;
          }

          const originalLabel = loadMore.textContent;
          loadMore.setAttribute('aria-disabled', 'true');
          loadMore.textContent = directory.dataset.loadingLabel;

          try {
            const response = await fetch(nextUrl, {
              headers: {'X-Requested-With': 'XMLHttpRequest'}
            });

            if (!response.ok) {
              throw new Error('Unable to load collections');
            }

            const html = await response.text();
            const nextDocument = new DOMParser().parseFromString(html, 'text/html');
            const nextGrid = nextDocument.querySelector('[data-collections-grid]');

            if (!nextGrid) {
              throw new Error('Collections grid not found');
            }

            const newItems = Array.from(nextGrid.children);

            newItems.forEach((item) => {
              grid.appendChild(document.importNode(item, true));
            });

            grid.dispatchEvent(new CustomEvent('theme:rimg:watch', {bubbles: true}));

            const nextButton = nextDocument.querySelector('[data-collections-load-more]');

            if (nextButton && nextButton.dataset.nextUrl) {
              loadMore.dataset.nextUrl = nextButton.dataset.nextUrl;
              loadMore.href = nextButton.dataset.nextUrl;
              loadMore.textContent = originalLabel;
              loadMore.removeAttribute('aria-disabled');

              if (status) {
                status.textContent = directory.dataset.loadedLabel;
              }
            } else {
              loadMore.closest('.collections-directory__load-more').hidden = true;

              if (status) {
                status.textContent = directory.dataset.allLoadedLabel;
              }
            }
          } catch (error) {
            window.location.assign(nextUrl);
          }
        });
      });
    };

    const initialize = () => initializeDirectory(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeDirectory(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
